type ParsedBody = { isJson: boolean; body: unknown }

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
export type ApiRequestOptions = RequestInit & { method?: HttpMethod; headers?: Record<string, string> }

export class ApiError extends Error {
    status: number
    data?: unknown

    constructor(status: number, message: string, data?: unknown) {
        super(message)
        this.status = status
        this.data = data
    }
}

export type RequestIds = { correlationId: string; requestId: string }

export function buildHeaders(
    token: string | null,
    extra: Record<string, string> | undefined,
    ids: RequestIds
): Record<string, string> {
    const authHeader: Record<string, string> = token ? {Authorization: `Bearer ${token}`} : {}
    const extraHeaders = {...(extra ?? {})}
    if (token && 'Authorization' in extraHeaders) {
        delete extraHeaders.Authorization
    }
    const baseHeaders: Record<string, string> = {
        'Content-Type': 'application/json',
        'X-Correlation-Id': ids.correlationId,
        'X-Request-Id': ids.requestId,
    }
    return {
        ...baseHeaders,
        ...extraHeaders,
        ...authHeader,
    }
}

export async function parseResponse(response: Response): Promise<ParsedBody> {
    const contentType = response.headers.get('content-type') || ''
    const isJson = contentType.includes('application/json')
    const body = isJson ? await response.json().catch(() => undefined) : await response.text()
    return {isJson, body}
}

export async function handleError<TResponse>(response: Response): Promise<TResponse> {
    const {isJson, body} = await parseResponse(response)
    const message =
        (isJson && body && typeof body === 'object' && 'message' in (body as any))
            ? String((body as any).message)
            : response.statusText || 'Request failed'
    throw new ApiError(response.status, message, body)
}
